<div class="button-wrapper" [ngClass]="customClass" fxLayoutAlign="center center" fxLayout="row">
    <button class="close-game-button" [ngClass]="customClass" [ngStyle]="{'position': !position ? 'absolute' : 'static'}" (click)="callLinkClickedParent()">
        <img src="{{licenceService.getKey('btn-close')}}" alt="close-btn" />
    </button>
</div>
